module.exports = __webpack_public_path__ + "img/challonge.258b1ad2.png";